<template>
  <div class="cardContainer">
    <lk-card>
      <h3 class="subTitle">用户咨询问题</h3>
      <lk-table
        :columns='columns'
        border
        :data='faqTable'
      ></lk-table>
       <h3 class="subTitle txt" v-if="questionList.length > 0">用药常见问题</h3>
        <lk-tabs  :animated='true'>
          <lk-tab-pane :label='item.approvedDrugNames || item.goodsName'  v-for="(item,index) in questionList" :key="index">
            <div class="questionCon" v-for="(subItem,index) in item.faqList" :key="index">
              <i class="TxtIcon"></i>
              <span class="answerCon">{{subItem.questionType}}</span><br>
              <span class="answerCon">{{subItem.answer}}</span>
            </div>
          </lk-tab-pane>
        </lk-tabs>
    </lk-card>
  </div>
</template>

<script>
import utils from '../../libs/utils';

export default {
  name: 'MedicationGuidance',
  components: {
  },
  props: {
    inquiryList: {
      type: Array,
    },
    medicationConsultation: {
      type: Array,
    },
    orderGoodsInquirys: {
      type: Array,
    },
    isEdit: {
      type: Boolean,
    },
  },
  model: {
    prop: 'orderGoodsInquirys',
    event: 'change',
  },
  computed: {
  },
  watch: {
    orderGoodsInquirys: {
      handler() {
        if (!this.isEdit) {
          this.faqTable = this.orderGoodsInquirys;
        }
      },
      deep: true,
    },
    medicationConsultation: {
      handler() {
        this.goodsUsageInfo = this.medicationConsultation;
        this.medicationConsultation.forEach((item) => {
          if (this.tempIds.indexOf(item.goodsBaseId) === -1) {
            this.isEdit ? this.faqList.push({
              goodsBaseId: item.goodsBaseId,
              approvedDrugNames: item.approvedDrugNames || item.goodsName,
            }) : null;
            if (item.faqList.length > 0) {
              this.questionList.push(item);
            }
            this.tempIds.push(item.goodsBaseId);
          }
        });
      },
      deep: true,
    },
  },
  data() {
    return {
      currentTime: '',
      faqList: [], // 咨询列表
      tempIds: [], // 去重暂存goodsBaseId
      questionList: [], // 问题list
      faqTable: [{
        createTime: new Date().getTime(),
      }], // 用户咨询问题
      columns: [
        {
          title: '咨询商品',
          width: 166,
          render: (h, { row, index }) => {
            const optionArr = this.faqList.map(item => h('lk-option', {
              props: {
                value: item.goodsBaseId,
              },
            }, item.approvedDrugNames));
            return this.isEdit ? h('lk-select',
              {
                props: {
                  value: row.goodsBaseId || '',
                  placeholder: '请选择药品',
                },
                on: {
                  'on-change': (value) => {
                    this.onChange(index, 'goodsBaseId', value);
                  },
                },
              },
              optionArr) : h('span', row.approvedDrugNames || '');
          },
        },
        {
          title: '咨询问题',
          minWidth: 166,
          render: (h, params) => h('lk-input', {
            on: {
              'on-blur': (e) => {
                this.onChange(params.index, 'question', e.target.value);
              },
            },
            props: {
              maxlength: 200,
              value: params.row.question || '',
              disabled: !this.isEdit,
            },
          }),
        },
        {
          title: '药师建议',
          minWidth: 166,
          // fixed: 'right',
          render: (h, params) => h('lk-input', {
            on: {
              'on-blur': (e) => {
                this.onChange(params.index, 'answer', e.target.value);
              },
            },
            props: {
              maxlength: 200,
              value: params.row.answer || '',
              disabled: !this.isEdit,
            },
          }),
        },
        {
          title: '咨询时间',
          width: 146,
          render: (h, params) => h('span', utils.formatTime(params.row.createTime)),
        },
        {
          title: '备注',
          width: 146,
          render: (h, params) => h('div', [
            h('lk-checkbox', {
              on: {
                'on-change': (e) => {
                  this.onChange(params.index, 'isReplyLater', e ? 1 : 2);
                },
              },
              props: {
                value: params.row.isReplyLater === 1,
                disabled: !this.isEdit,
              },
            }),
            h('span', '稍后回复')]),
        },
        {
          title: '操作',
          width: 160,
          render: (h, params) => {
            const idx = this.faqTable.length - 1;
            return h('div', [
              h('lk-button', {
                props: {
                  type: 'text',
                  disabled: idx === 0 || !this.isEdit,
                },
                on: {
                  click: () => {
                    this.onDelete(params.index);
                  },
                },
              }, '删除'),
              idx === params.index
                ? h('lk-button', {
                  props: {
                    type: 'text',
                    disabled: !this.isEdit,
                  },
                  on: {
                    click: () => {
                      this.handlerAddClick();
                    },
                  },
                }, '新增') : '',
            ]);
          },
        },
      ],
      format: [
        'image/png',
        'image/jpeg',
        'image/gif',
        'application/pdf',
      ],
      val: 1,
      goodsUsageInfo: {
        goodsUsageAttention: '', // 用药注意事项
        goodsUsageNursing: '', // 用药护理方案
        goodsUsageFinance: '', // 用药金融方案
        cardUrl: '', // 药学服务卡
        goodsBaseFaqVo: [
          {
            question: '',
            answer: '',
            isReplyLater: '',
          },
        ],
      },
    };
  },
  methods: {
    handlerAddClick() {
      this.faqTable.push({
        createTime: new Date().getTime(),
      });
    },
    onDelete(index) {
      this.faqTable.splice(index, 1);
    },
    onChange(idx, str, value) {
      this.$set(this.faqTable[idx], str, value);
      this.$emit('change', this.faqTable);
    },
  },

  created() {
  },
  mounted() {
    this.tempIds = [];
  },
};
</script>

<style lang="less" scoped>
.cardContainer {
  .subTitle {
   margin-bottom: 20px;
  }
  .txt {
    margin-top: 50px;
  }
  .questionCon {
    padding: 10px 10px;
  }
  .answerCon {
    word-wrap:break-word;
  }
  .TxtIcon {
    display: inline-block;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: #000;
    margin: 0 2px 2px 0;
  }
}
</style>
